import { useEffect, useState } from 'react';
import { getProductFormats } from '../api/settingsApi';
import { buildProductFormatOptions, PRODUCT_FORMAT_OPTIONS } from '../utils/clientType';

const useProductFormatOptions = ({ activeOnly = true } = {}) => {
  const [options, setOptions] = useState(PRODUCT_FORMAT_OPTIONS);

  useEffect(() => {
    let mounted = true;
    const loadFormats = async () => {
      try {
        const data = await getProductFormats({ activeOnly: activeOnly ? 'true' : 'false' });
        if (!mounted) return;
        setOptions(buildProductFormatOptions(data?.formats));
      } catch {
        if (mounted) setOptions(PRODUCT_FORMAT_OPTIONS);
      }
    };
    loadFormats();
    return () => {
      mounted = false;
    };
  }, [activeOnly]);

  return options;
};

export default useProductFormatOptions;
